import { createPushStateNavigator, type PushStateNavigator } from '../push-state-navigator';

let navigatorPromise: Promise<PushStateNavigator>;
export const getPushStateNavigator = () => {
	if (!navigatorPromise) {
		navigatorPromise = createPushStateNavigator();
	}
	return navigatorPromise;
};
